import Cookies from "js-cookie";
import { SESSION_STORAGE_SIDE_NAV_EXPANDED } from "./constants";
import { COOKIE_TOKEN } from "./constants";

export const getLoginToken = () =>
  Cookies.get(COOKIE_TOKEN) ||
  (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_IV_LOGIN_TOKEN);

export const removeToken = (
  name = "",
  domain = "",
  path = "/",
  redirectUrl = null
) => {
  Cookies.remove(name, { path: path, domain: domain });
  if (redirectUrl) {
    window.top.location.href = redirectUrl;
  }
};

export const orderProjects = (p) =>
  [...p].sort((a, b) => a.display_name.localeCompare(b.display_name));

export const arrayDiff = (arr1, arr2) => arr1.filter((e) => !arr2.includes(e));

export const getPathTarget = (path) => {
  return path
    .substring(path.lastIndexOf("/") + 1)
    .split("?")[0]
    .toLowerCase();
};

export const setExpandedDrawer = (item) => {
  sessionStorage.setItem(SESSION_STORAGE_SIDE_NAV_EXPANDED, item);
};

export const parseFileSegmentsData = (attributes) => {
  const sortedAttributes = sortSegmentAttributesByKey(attributes);
  const segments = structuredClone(defaultSegmentsData);
  const charCodeOffset = 65;
  let skipSegment = "";
  let charCode = null;
  let selectableSubSegments = {};

  for (const segment in sortedAttributes) {
    if (segment.length === 1) {
      if (sortedAttributes[segment] === 0) {
        skipSegment = segment;
        continue;
      }

      charCode = segment.charCodeAt(0);
      segments[charCode - charCodeOffset].percentage =
        sortedAttributes[segment];
    } else {
      if (segment[0] === skipSegment || sortedAttributes[segment] === 0) {
        continue;
      }

      let subSegment =
        segments[charCode - charCodeOffset].subSegments[segment[1] - 1];

      subSegment.percentage = sortedAttributes[segment];
      selectableSubSegments[subSegment.name] = subSegment.percentage;
    }
  }

  return [segments, selectableSubSegments];
};

export const getSegmentsTotal = (selectedSubSegments, fileTotals) => {
  var addressableHouseholds = 0;
  var addressableAudiencePool = 0;
  selectedSubSegments.forEach((selectedSubSegment) => {
    if (
      fileTotals[selectedSubSegment]?.household_totals &&
      fileTotals[selectedSubSegment]?.digital_totals
    ) {
      addressableHouseholds += fileTotals[selectedSubSegment].household_totals;
      addressableAudiencePool += fileTotals[selectedSubSegment].digital_totals;
    }
  });
  return [addressableHouseholds, addressableAudiencePool];
};

export const poll = async ({ fn, validate, interval, maxAttempts }) => {
  let attempts = 0;

  const executePoll = async (resolve, reject) => {
    const result = await fn();

    attempts++;
    if (validate(result)) {
      return resolve(result);
    } else if (maxAttempts && attempts === maxAttempts) {
      return reject(new Error("Request timed out, please try again."));
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };

  return new Promise(executePoll);
};

export const defaultSegmentsData = [
  { segment: "A", subSegments: 5 },
  { segment: "B", subSegments: 5 },
  { segment: "C", subSegments: 5 },
  { segment: "D", subSegments: 5 },
  { segment: "E", subSegments: 5 },
  { segment: "F", subSegments: 5 },
  { segment: "G", subSegments: 5 },
  { segment: "H", subSegments: 4 },
  { segment: "I", subSegments: 3 },
  { segment: "J", subSegments: 5 },
  { segment: "K", subSegments: 4 },
  { segment: "L", subSegments: 4 },
  { segment: "M", subSegments: 4 },
  { segment: "N", subSegments: 5 },
  { segment: "O", subSegments: 5 },
  { segment: "P", subSegments: 5 },
  { segment: "Q", subSegments: 5 },
  { segment: "R", subSegments: 5 },
  { segment: "S", subSegments: 5 },
  { segment: "T", subSegments: 5 },
].map(({ segment, subSegments }) => {
  const group = Array.from({ length: subSegments }, (_, i) => ({
    name: `${segment}${i + 1}`,
    percentage: 0,
  }));
  return { name: segment, percentage: 0, subSegments: group };
});

function sortSegmentAttributesByKey(object) {
  // filter for segments data
  const segments = Object.keys(object)
    .filter((item) => item.indexOf("Seg") === 0 && item.length <= 5)
    .reduce((p, key) => Object.assign(p, { [key]: object[key] }), {});

  return Object.entries(segments)
    .sort()
    .reduce((o, [k, v]) => {
      // removes 'Seg' prefix of object key
      o[k.slice(3).toUpperCase()] = v;
      return o;
    }, {});
}
